(ns web3.components.video)

(defn youtube [{:keys [youtube-id]}]
  [:div.flex.items-center.justify-center.pad-all-4
   [:iframe {:width 560
             :height 315
             :src (str "https://www.youtube.com/embed/" youtube-id)
             :frameborder 0
             :allowfullscreen true} "youtube" youtube-id]])